import forge from 'node-forge';

// Client-side card encryption shared by the billing pages: a random AES-256 key encrypts
// the card JSON (AES-CBC), and that AES key is itself wrapped with the server's RSA public
// key (RSA-OAEP) during the key exchange. Mirrors the scheme in src/pages/PaymentInfo.

export const generateAES256Key = () => forge.random.getBytesSync(32);

export const encryptAESKeyWithRSAPublicKey = (aesKey, rsaPublicKeyPem) => {
    const publicKey = forge.pki.publicKeyFromPem(rsaPublicKeyPem);
    return publicKey.encrypt(aesKey, 'RSA-OAEP');
};

export const encryptDataWithAESKey = (data, aesKey) => {
    const cipher = forge.cipher.createCipher('AES-CBC', aesKey);
    const iv = forge.random.getBytesSync(16);
    cipher.start({ iv });
    cipher.update(forge.util.createBuffer(data));
    cipher.finish();
    return { encryptedData: cipher.output.getBytes(), iv };
};

// Produces the base64 envelope the backend expects: { encryptedData, iv } (both base64).
export const buildEncryptedCardPayload = (cardData, aesKey) => {
    const { encryptedData, iv } = encryptDataWithAESKey(JSON.stringify(cardData), aesKey);
    return forge.util.encode64(
        JSON.stringify({
            encryptedData: forge.util.encode64(encryptedData),
            iv: forge.util.encode64(iv),
        })
    );
};
